<template>
  <div class="sidebar-logo-container" >
    <transition name="sidebarLogoFade">
      <router-link key="expand" class="sidebar-logo-link" to="/home">
        <img  src="@/assets/logo.png" class="sidebar-logo">
        <h3 class="sidebar-title">{{ title }} </h3>
        <!-- <h5>{{homeInfo.sysDepart.departName}}</h5> -->
      </router-link>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'SidebarLogo',
  props: {
    collapse: {
      type: Boolean,
      required: false,
      timerId:0 ,
    }
  },
  data() {
    return {
      logo: '',
      homeInfo:{
        sysDepart:{
          departName: "" // 部门名称占位
        }
      },
      title:"",
    }
  },
  computed: {
    
  },
  mounted(){
    console.log("logo mounted.");
    this.getTitle();

    this.timerId = setInterval(() => {
      console.log("forceUpdate...");
      this.getTitle();
    }, 5000);
  },
  methods: {
    // 获取首页信息
    getTitle(){
      let homeInfo = JSON.parse(localStorage.getItem('homeInfo'));
      let deptName = homeInfo.sysDepart.departName;
      this.title =  deptName;
    }
  },

}
</script>

<style lang="scss" scoped>
.sidebarLogoFade-enter-active {
  transition: opacity 1.5s;
}

.sidebarLogoFade-enter,
.sidebarLogoFade-leave-to {
  opacity: 0;
}

.sidebar-logo-container {
  position: relative;
  width: 100%;
  padding: 12px 0;
  text-align: center;
  overflow: hidden;

  & .sidebar-logo-link {
    height: 100%;
    width: 100%;

    & .sidebar-logo {
      display: block;
      width: 48px;
      height: 58px;
      margin: 0 auto;
    }

    & .sidebar-title {
      display: inline-block;
      margin: 0;
      color: #fff;
      font-size: 14px;
      font-weight: 600;
      line-height: 1.3;
      margin-top: 8px;
      max-width: 100px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
</style>
